<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Edit Release #{{ $route.params.id | makeIDSixDigits }}</span>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field
                                    label="Status"
                                >
                                    <b-select
                                        placeholder="Select a Status"
                                        expanded
                                        v-model="data.status"
                                        :disabled="!canManageRelease"
                                    >
                                        <option :value="null">Please Select</option>
                                        <option
                                            v-for="(status, index) in statuses"
                                            :key="index"
                                            :value="status"
                                        >{{ status.toUpperCase() }}</option>
                                    </b-select>
                                </b-field>
                                <b-field
                                    label="App"
                                    v-show="apps.length>1">
                                    <app-filter v-model="data.app_id" expanded :preSelect="data.app_id"
                                    :disabled="!canManageRelease"></app-filter>
                                </b-field>
                                <b-field label="Name">
                                    <b-input v-model="data.name" 
                                    :disabled="!canManageRelease"></b-input>
                                </b-field>

                                <label class="label" v-if="formatExpectedTestDate()!==null && isRole('gatekeeper')">Expected Test Date</label>
                                <div class="field is-grouped" v-if="formatExpectedTestDate()!==null && isRole('gatekeeper')">
                                    <b-datepicker
                                        placeholder="Select Start Date"
                                        editable
                                        icon="calendar-today"
                                        v-model="expectedTestDate"
                                        expanded
                                        :disabled="!canManageRelease"
                                    ></b-datepicker>
                                    <b-timepicker
                                        placeholder="Type or Select a Time"
                                        icon="clock"
                                        v-model="expectedTestTime"
                                        editable
                                        expanded
                                        :disabled="!canManageRelease"
                                    ></b-timepicker>
                                </div>

                                <label class="label" v-if="formatReleaseTestDate()!==null && isRole('gatekeeper')">Expected Release Date</label>
                                <div class="field is-grouped" v-if="formatReleaseTestDate()!==null && isRole('gatekeeper')">
                                    <b-datepicker
                                        placeholder="Select Start Date"
                                        editable
                                        icon="calendar-today"
                                        v-model="releaseTestDate"
                                        expanded
                                        :disabled="!canManageRelease"
                                    ></b-datepicker>
                                    <b-timepicker
                                        placeholder="Type or Select a Time"
                                        icon="clock"
                                        v-model="releaseTestTime"
                                        editable
                                        expanded
                                        :disabled="!canManageRelease"
                                    ></b-timepicker>
                                </div>

                                <b-field label="Details">
                                    <b-input type="textarea" v-model="data.details" 
                                        :disabled="!canManageRelease"></b-input>
                                </b-field>

                                <section class="m-t-md">
                                    <b-button
                                        type="is-default m-r-sm"
                                        @click.prevent="goBack()"
                                    >Back</b-button>
                                    <b-button type="is-success m-r-sm" @click.prevent="update" v-if="isRole('serviceperson')">Save</b-button>
                                </section>
                            </div>
                            <div class="column is-half">
                                <b-field v-if="tickets.length > 0">
                                    <template #label>
                                            <div class="p-b-sm">
                                                Related Tickets
                                                <div class="is-pulled-right">
                                                    <b-button @click="goTo('tickets',{},{release_id:$route.params.id})">
                                                        Show Tickets
                                                    </b-button>
                                                </div>
                                            </div>
                                    </template>
                                    <div class="list">
                                        <a
                                            class="list-item"
                                            v-for="ticket in tickets"
                                            :key="ticket.id"
                                            @click.prevent="goTo('tickets.edit',{id:ticket.id})"
                                        >#{{ ticket.id | makeIDSixDigits }}</a>
                                    </div>
                                </b-field>


                                <comments :type_id="$route.params.id" :type="`releases`"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import comments from "@/pages/_includes/comments";
import AppFilter from '../../../../components/AppFilter.vue';

export default {
    data() {
        return {
            data: {
                status: null,
                name: null,
                details: null,
                app_id: null
            },
            tickets: [],
            apps:[],
            statuses: ["pending", "deployed", "void"],
            expectedTestDate: null,
            expectedTestTime: null,
            releaseTestDate: null,
            releaseTestTime: null
        };
    },
    components: {
        comments,
        AppFilter
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },

        auth: {
            get() {
                return this.$store.state.auth;
            }
        },
        canManageRelease(){
            return this.auth.permissions.includes('can_manage_release') || this.isRole('serviceperson')
        }
    },
    mounted() {
        this.getRelease();
        this.getAppList();
    },
    methods: {
        getRelease() {
            this.loading = true;
            Vue.$releaseService
                .getRelease(this.$route.params.id)
                .then(response => {
                    this.data.status = response.data.attributes.status;
                    this.data.name = response.data.attributes.name;
                    this.data.details = response.data.attributes.details;
                    this.data.app_id = response.data.attributes.app_id;
                    if (response.included) {
                        this.tickets = response.included.filter(
                            include => include.type == "tickets"
                        );
                    }
                    this.expectedTestDate = response.data.attributes
                        .expected_test_date
                        ? new Date(response.data.attributes.expected_test_date)
                        : null;
                    this.releaseTestDate = response.data.attributes
                        .expected_release_date
                        ? new Date(
                              response.data.attributes.expected_release_date
                          )
                        : null;
                    this.expectedTestTime = this.expectedTestDate;
                    this.releaseTestTime = this.releaseTestDate;
                    this.loading = false;
                });
        },
        getAppList() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
                this.loading = false;
            });
        },
        update() {
            this.loading = true;

            let data = {
                status: this.data.status,
                name: this.data.name,
                details: this.data.details,
                app_id: this.data.app_id,
                expected_test_date: this.formatExpectedTestDate(),
                expected_release_date: this.formatReleaseTestDate(),
            };

            Vue.$releaseService
                .updateRelease(this.$route.params.id, data)
                .then(() => {
                    this.$buefy.toast.open({
                        type:'is-success',
                        message:'Release saved!'
                    })
                    this.loading = false;

                    this.$router.push({
                        name: "releases"
                    });
                }).catch(()=>{
                    this.loading = false;
                });
        },
        goBack() {
            this.$store.commit("SET_ERRORS", null);
            this.$router.push({
                name: "releases"
            });
        },
        goTo(name,params = null, query=null) {
            this.$router.push({
                name: name,
                params: params,
                query:query
            });
        },

        formatExpectedTestDate() {
            if (this.expectedTestDate && this.expectedTestTime) {
                let date =
                    moment(this.expectedTestDate).format("YYYY-MM-DD") +
                    " " +
                    moment(this.expectedTestTime).format("HH:mm");

                return date;
            }
            return null;
        },

        formatReleaseTestDate() {

            if (this.releaseTestDate && this.releaseTestTime) {
                let date =
                    moment(this.releaseTestDate).format("YYYY-MM-DD") +
                    " " +
                    moment(this.releaseTestTime).format("HH:mm");

                return date;
            }
            return null;
        }
    }
};
</script>